module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "row",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('SelectOption', {
    staticClass: "col-sm-6",
    attrs: {
      "id": "form-months",
      "placeholder": "Wybierz miesiąc",
      "options": _vm.months
    },
    model: {
      value: (_vm.monthSelected),
      callback: function($$v) {
        _vm.monthSelected = $$v
      },
      expression: "monthSelected"
    }
  }), _vm._v(" "), _c('SelectOption', {
    staticClass: "col-sm-6",
    attrs: {
      "id": "form-years",
      "placeholder": "Wybierz rok",
      "options": _vm.years
    },
    model: {
      value: (_vm.yearSelected),
      callback: function($$v) {
        _vm.yearSelected = $$v
      },
      expression: "yearSelected"
    }
  }), _vm._v(" "), _c('vs-switch', {
    model: {
      value: (_vm.modeSelected),
      callback: function($$v) {
        _vm.modeSelected = $$v
      },
      expression: "modeSelected"
    }
  }, [_c('span', {
    attrs: {
      "slot": "on"
    },
    slot: "on"
  }, [_vm._v("Zwykły")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "off"
    },
    slot: "off"
  }, [_vm._v("Pełny")])]), _vm._v(" "), _c('vs-switch', {
    staticClass: "switch-place-view",
    model: {
      value: (_vm.placeSelected),
      callback: function($$v) {
        _vm.placeSelected = $$v
      },
      expression: "placeSelected"
    }
  }, [_c('span', {
    attrs: {
      "slot": "on"
    },
    slot: "on"
  }, [_vm._v("Według dat")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "off"
    },
    slot: "off"
  }, [_vm._v("Według miejsc")])]), _vm._v(" "), _c('vs-switch', {
    staticClass: "switch-archived-view",
    model: {
      value: (_vm.archivedSelected),
      callback: function($$v) {
        _vm.archivedSelected = $$v
      },
      expression: "archivedSelected"
    }
  }, [_c('span', {
    attrs: {
      "slot": "on"
    },
    slot: "on"
  }, [_vm._v("Wszyscy")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "off"
    },
    slot: "off"
  }, [_vm._v("Aktywni")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1458c38a!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/YearMonthForm.vue
// module id = 1085
// module chunks = 0